import React from 'react';
import { func, object, oneOfType } from 'prop-types';

import AlertProvider from '@/context/alert';
import useAuth from './useAuth';
import useHomeData from './useHomeData';

const FirstRoute = ({ component: Component, ...rest }) => {
  useAuth(); // Handle navigation logic
  useHomeData(); // Fetch data once on mount

  return (
    <AlertProvider>
      <div style={{ height: '100%' }}>
        <Component {...rest} />
      </div>
    </AlertProvider>
  );
};

FirstRoute.propTypes = {
  component: oneOfType([object, func]),
};

FirstRoute.defaultProps = {
  component: null,
};

export default FirstRoute;
